Object.defineProperty(exports,"__esModule",{value:true});exports.getSecurityDeviceArmState=undefined;





var _types=require('./types');
var _SecurityDevice=require('../model/SecurityDevice');





var getSecurityDeviceArmState=exports.getSecurityDeviceArmState=function getSecurityDeviceArmState(
originalDevice)
{
if(!originalDevice){
return null;
}


var device=originalDevice.getArmDevice();

if(!device){
return null;
}var

alarming=device.alarming,locked=device.locked,open=device.open,armed=device.armed,silentAlarming=device.silentAlarming;

if(alarming){
return{type:_types.armState.ALARMING};
}

if(silentAlarming){
return{type:_types.armState.SILENT_ALARMING};
}

if(device.isLock()){var
unhealthyReason=device.unhealthyReason;

if(open&&!unhealthyReason){
return{type:_types.armState.OPEN};
}

if(locked){
return{type:_types.armState.LOCKED};
}

if(!unhealthyReason){
return{
type:_types.armState.UNLOCKED,
payload:{
text:device.getUnlockedTime(),
warning:device.hasExceededUnlockTimeThreshold()}};


}

if(unhealthyReason===_SecurityDevice.unhealthyReason.LOCK_STUCK){
return{type:_types.armState.UNLOCKED,payload:{text:'X',warning:true}};
}else if(unhealthyReason===_SecurityDevice.unhealthyReason.LOCK_STUCK_UNLOCKED){
return{type:_types.armState.UNLOCKED,payload:{text:'X',warning:true}};
}else if(unhealthyReason===_SecurityDevice.unhealthyReason.LOST_COMM){
return{
type:_types.armState.UNLOCKED,
payload:{text:'))x',warning:true}};

}
}

if(armed===true){
return{type:_types.armState.ARMED};
}else{
return{type:_types.armState.DISARMED};
}

return{type:_types.armState.OTHER_STATE};
};